module.exports = __webpack_public_path__ + "47e0d160f0b6c8fdb746527cc1934bb6.mp3";